import { useRef, useEffect } from 'react'


interface PropertyPanelProps {
  title: string
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export function PropertyPanel({ title, isOpen, onClose, children }: PropertyPanelProps) {
  const panelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    if (isOpen) window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [isOpen, onClose])

  return (
    <>
      {/* Panel (No blocking backdrop) */}
      <aside
        ref={panelRef}
        className={`fixed top-0 right-0 bottom-0 w-[480px] bg-bg-panel border-l border-border z-40 transition-transform duration-200 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h2 className="text-sm font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-sm hover:bg-bg-hover transition-colors"
          >
            ✕
          </button>
        </div>
        {/* Body */}
        <div className="overflow-y-auto h-[calc(100%-49px)] p-4">
          {children}
        </div>
      </aside>
    </>
  )
}
